import makeStyles from '@mui/styles/makeStyles';
const reqStyles = makeStyles({
    root: {
      width:'100%',
      height:'100vh',
      fontFamily:'Ubuntu'
    },
    box:{
      marginTop:50,
        width:800,
        height:'auto',
        border:'1px solid #2c3e50',
        borderRadius:5,
        padding:15
    },
    dbox:{
      width:1000,
      height:600,
      border:'1px solid #2c3e50',
      borderRadius:5,
      padding:15
  },
    HelperText:{

 
    color: "#d32f2f",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    textAlign: "left",
    marginTop: "3px",
    marginBottom: "0",
   
  }


    
  });
  export{reqStyles}